import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.button`
  background: #003399;
  display: block;
  border: 0;
  border-radius: 16px;
  height: 40px;
  width: 100%;
  margin-top: 20px;

  color: #fff;
  font-weight: 700;
  font-size: 16px;

  transition: background-color 0.2s ease-in-out;

  &:hover:enabled {
    background: ${darken(0.025, '#003399')};
  }
`;
